import { LocalFile } from 'contexts/project/ProjectContext';
import { IConvertFile } from 'lib/types/clinic/fileTypes';
import { createStoreWithSetters } from './utils';

interface IStoreProps {
  isPmsView: boolean;
  localFiles: LocalFile[];
  convertFiles: any[];
  isOwnerStorage: boolean;
  isShareStorage: boolean;
  isLocalStorage: boolean;
  isCheckboxChecked: boolean;
  viewModelFiles: IConvertFile[];
  viewImageFile: IConvertFile | null;
  viewHtmlFile: IConvertFile | null;
  uploadLocalFiles: IConvertFile[];
  uploadShareType: 1 | 2;
  isOpenRemoveModal: boolean;
  isOpenDuplicateModal: boolean;
  isOpenDuplicateModalType: 'partner' | 'group';
  removeType: 'all' | 'partner' | 'group' | 'local';
  localFileDeleteSuccess: boolean;
  isLocalFileExist: boolean;
  modelError: Error | null;
}

export const useProjectFileStore = createStoreWithSetters<IStoreProps>(
  {
    isPmsView: false,
    localFiles: [],
    convertFiles: [],
    isOwnerStorage: false,
    isShareStorage: false,
    isLocalStorage: false,
    isCheckboxChecked: false,
    viewModelFiles: [],
    viewImageFile: null,
    viewHtmlFile: null,
    uploadLocalFiles: [],
    uploadShareType: 1,
    isOpenRemoveModal: false,
    isOpenDuplicateModal: false,
    isOpenDuplicateModalType: 'group',
    removeType: 'all',
    localFileDeleteSuccess: false,
    isLocalFileExist: false,
    modelError: null,
  },
  'project_file',
);
